import { useFormik } from "formik";
import * as yup from "yup";
import { ProfileLineItem } from "@interfaces/profile";
import { FormControlLabel, FormGroup, Switch, Grid, Box } from "@mui/material";
import {
  StyledButton,
  StyledLoadingButton,
} from "@stories/atoms/StyledButton/StyledButton";
import { StyledTextField } from "@stories/atoms/StyledTextField/StyledTextField";
import SaveIcon from "@mui/icons-material/Save";

interface AdminProfileFormProps {
  loading: boolean;
  profile: ProfileLineItem;
  handleBack: () => void;
  finalizeAccount: (profile: ProfileLineItem) => void;
}

export const AdminProfileForm = ({
  loading,
  profile,
  finalizeAccount,
  handleBack,
}: AdminProfileFormProps) => {
  const validationSchema = yup.object({
    name: yup.string().required("Name is required"),
    emailNotifications: yup.boolean().required("Email notifications required"),
  });
  const formik = useFormik({
    initialValues: {
      name: profile.name,
      emailNotifications: profile.emailNotifications,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      finalizeAccount({
        ...profile,
        name: values.name,
        emailNotifications: values.emailNotifications,
        invited: false,
      } as ProfileLineItem);
    },
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <StyledTextField
              id="name"
              name="name"
              label="Name"
              fullWidth
              margin="dense"
              disabled={loading || formik.isSubmitting}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name ? formik.errors.name : ""}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    defaultChecked
                    disabled={loading || formik.isSubmitting}
                    value={formik.values.emailNotifications}
                    onChange={(event, checked) => {
                      formik.setFieldValue("emailNotifications", checked);
                    }}
                  />
                }
                label="Email Notifications"
              />
            </FormGroup>
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            sx={{
              display: "flex !important",
              justifyContent: "left !important;",
            }}
          >
            <StyledButton
              variant="contained"
              onClick={handleBack}
              disabled={loading || formik.isSubmitting}
            >
              Back
            </StyledButton>
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            sx={{
              display: "flex !important",
              justifyContent: "right !important;",
            }}
          >
            <StyledLoadingButton
              color="primary"
              type="submit"
              loading={loading}
              disabled={loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
            >
              Save
            </StyledLoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
